module.exports = __webpack_public_path__ + "static/media/boss_cafe.3118217e.svg";